export enum PropertyRelationshipType {
  PROPRIETARIO = 'PROPRIETARIO',
  INQUILINO = 'INQUILINO',
  PARENTE = 'PARENTE',
  AVVOCATO = 'AVVOCATO',
  CUSTODE = 'CUSTODE',
  ALTRO = 'ALTRO',
}
